/**
 * Friendly / legacy aliases → canonical schematic kind.
 */
export var SCHEMATIC_ALIASES = {
    // legacy
    switch: 'spst',
    // common synonyms
    gnd: 'ground',
    earth: 'earthGround',
    earth_ground: 'earthGround',
    chassis_ground: 'chassisGround',
    signal_ground: 'signalGround',
    dc_supply: 'dcSupply',
    ac_supply: 'acSupply',
    voltage_source: 'voltageSource',
    current_source: 'currentSource',
    circuit_breaker: 'circuitBreaker',
    variable_resistor: 'variableResistor',
    pot: 'potentiometer',
    trimmer_potentiometer: 'trimmer',
    thermistor_ntc: 'thermistorNtc',
    thermistor_ptc: 'thermistorPtc',
    ntc: 'thermistorNtc',
    ptc: 'thermistorPtc',
    ldr: 'photoresistor',
    mov_varistor: 'varistor',
    electrolytic: 'electrolyticCap',
    electrolytic_capacitor: 'electrolyticCap',
    variable_capacitor: 'variableCap',
    variable_inductor: 'variableInductor',
    ferrite_bead: 'ferriteBead',
    rf_coil: 'rfCoil',
    ceramic_resonator: 'ceramicResonator',
    schottky_diode: 'schottky',
    zener_diode: 'zener',
    tvs_diode: 'tvs',
    ir_led: 'infraredLed',
    infrared_led: 'infraredLed',
    laser_diode: 'laserDiode',
    bridge_rectifier: 'bridgeRectifier',
    tunnel_diode: 'tunnelDiode',
    varactor: 'varicap',
    npn_bjt: 'npn',
    pnp_bjt: 'pnp',
    n_channel_mosfet: 'nmos',
    p_channel_mosfet: 'pmos',
    nmosfet: 'nmos',
    pmosfet: 'pmos',
    n_channel_jfet: 'njfet',
    p_channel_jfet: 'pjfet',
    darlington_transistor: 'darlington',
    not: 'notGate',
    and: 'andGate',
    nand: 'nandGate',
    or: 'orGate',
    nor: 'norGate',
    xor: 'xorGate',
    xnor: 'xnorGate',
    schmitt: 'schmittTrigger',
    opamp: 'opAmp',
    op_amp: 'opAmp',
    instrumentation_amplifier: 'instrumentationAmp',
    voltage_comparator: 'voltageComparator',
    voltage_reference: 'voltageReference',
    voltage_regulator: 'voltageRegulator',
    ldo_regulator: 'ldo',
    buck_converter: 'buck',
    boost_converter: 'boost',
    microcontroller: 'mcu',
    microprocessor: 'mpu',
    flash_memory: 'flash',
    real_time_clock: 'rtc',
    timer_ic: 'timerIc',
    shift_register: 'shiftRegister',
    multiplexer: 'mux',
    demultiplexer: 'demux',
    flip_flop: 'flipFlop',
    temperature_sensor: 'tempSensor',
    humidity_sensor: 'humiditySensor',
    pressure_sensor: 'pressureSensor',
    light_sensor: 'lightSensor',
    hall_effect_sensor: 'hallSensor',
    current_sensor: 'currentSensor',
    voltage_sensor: 'voltageSensor',
    gas_sensor: 'gasSensor',
    ultrasonic_sensor: 'ultrasonicSensor',
    proximity_sensor: 'proximitySensor',
    pir_sensor: 'pirSensor',
    touch_sensor: 'touchSensor',
    reed_relay: 'reedRelay',
    dc_motor: 'dcMotor',
    ac_motor: 'acMotor',
    stepper_motor: 'stepperMotor',
    servo_motor: 'servoMotor',
    piezo_buzzer: 'piezoBuzzer',
    indicator_led: 'indicatorLed',
    seven_segment: 'sevenSegment',
    seven_segment_display: 'sevenSegment',
    oled_display: 'oled',
    spst_switch: 'spst',
    spdt_switch: 'spdt',
    dpst_switch: 'dpst',
    dpdt_switch: 'dpdt',
    push_button: 'pushButtonNo',
    push_button_no: 'pushButtonNo',
    push_button_nc: 'pushButtonNc',
    toggle_switch: 'toggleSwitch',
    slide_switch: 'slideSwitch',
    dip_switch: 'dipSwitch',
    rotary_switch: 'rotarySwitch',
    reed_switch: 'reedSwitch',
    limit_switch: 'limitSwitch',
    key_switch: 'keySwitch',
    emergency_stop: 'eStop',
    emergency_stop_switch: 'eStop',
    terminal_block: 'terminalBlock',
    usb_connector: 'usbConnector',
    rj45_connector: 'rj45',
    hdmi_connector: 'hdmi',
    db9_connector: 'db9',
    barrel_jack: 'barrelJack',
    coaxial_connector: 'coax',
    sma_connector: 'sma',
    bnc_connector: 'bnc',
    can_bus: 'canBus',
    lin_bus: 'linBus',
    rs_232: 'rs232',
    rs_485: 'rs485',
    ethernet_phy: 'ethernetPhy',
    bluetooth_module: 'bluetooth',
    wifi_module: 'wifi',
    nfc_module: 'nfc',
    zigbee_module: 'zigbee',
    lora_module: 'lora',
    gps_module: 'gps',
    esd: 'esdProtection',
    esd_protection: 'esdProtection',
    gas_discharge_tube: 'gdt',
    spark_gap: 'sparkGap',
    reverse_polarity: 'reversePolarity',
    test_point: 'testPoint',
    oscilloscope_probe: 'scopeProbe',
    current_shunt: 'currentShunt',
    connector_shield: 'connectorShield',
    mounting_hole: 'mountingHole',
    mounting_pad: 'mountingPad',
    net_label: 'netLabel',
    no_connect: 'noConnect',
    nc: 'noConnect',
    off_page_connector: 'offPageConnector',
    sheet_connector: 'sheetConnector',
};
